import { resetStore } from '../redux/actions';
import { routeAuth } from '../pages/AuthPage';

export const handleLogout = (dispatch, navigate) => {
    try {
        // 1. Сначала очищаем localStorage
        localStorage.removeItem('persist:autoplace');

        // Очищаем все persist ключи
        if (typeof Storage !== 'undefined') {
            Object.keys(localStorage).forEach(key => {
                if (key.startsWith('persist:')) {
                    localStorage.removeItem(key);
                }
            });
        }

        // 2. Очищаем Redux store
        if (dispatch && typeof dispatch === 'function') {
            dispatch(resetStore());
        }

        // 3. Немедленный редирект без ожидания
        const loginPath = routeAuth();

        if (navigate && typeof navigate === 'function') {
            // Используем navigate для программного перенаправления
            setTimeout(() => navigate(loginPath), 0);
        } else {
            // Фоллбэк - принудительный редирект через window.location
            window.location.replace(loginPath);
        }

    } catch (error) {
        console.error('Ошибка при выходе из системы:', error);
        // В случае ошибки все равно перенаправляем на login
        window.location.replace(routeAuth());
    }
};

// Альтернативная функция для ручного выхода (для кнопки "Выйти")
export const handleManualLogout = (dispatch) => {
    try {
        // Очищаем localStorage
        localStorage.removeItem('persist:autoplace');

        if (typeof Storage !== 'undefined') {
            Object.keys(localStorage).forEach(key => {
                if (key.startsWith('persist:')) {
                    localStorage.removeItem(key);
                }
            });
        }

        // Очищаем store
        if (dispatch && typeof dispatch === 'function') {
            dispatch(resetStore());
        }

        // Принудительный редирект
        window.location.replace(routeAuth());

    } catch (error) {
        console.error('Ошибка при ручном выходе:', error);
        window.location.replace(routeAuth());
    }
};